/* Creative Fabula — placeholder illustration engine.
 * Draws minimalist Scandinavian-poster scenes as SVG strings.
 * Used in the browser (covers, demo pages) and on the server (sample PDF).
 * When a Grok API key is configured, real illustrations replace these for pages. */
(function (root) {
  const W = 400, H = 400;

  function hills(y, amp, color, phase) {
    let d = `M0 ${H} L0 ${y}`;
    for (let x = 0; x <= W; x += 20) {
      const yy = y + Math.sin((x / W) * Math.PI * 2 + phase) * amp + Math.sin((x / W) * Math.PI * 5 + phase * 2) * (amp / 4);
      d += ` L${x} ${yy.toFixed(1)}`;
    }
    return `<path d="${d} L${W} ${H} Z" fill="${color}"/>`;
  }

  function stars(n, seed, color) {
    let s = '', r = seed;
    for (let i = 0; i < n; i++) {
      r = (r * 9301 + 49297) % 233280;
      const x = (r / 233280) * W;
      r = (r * 9301 + 49297) % 233280;
      const y = (r / 233280) * 170;
      s += `<circle cx="${x.toFixed(0)}" cy="${y.toFixed(0)}" r="${i % 3 ? 1.2 : 2}" fill="${color}" opacity=".85"/>`;
    }
    return s;
  }

  const MOTIFS = {
    barn: (c) => `
      <g transform="translate(150 215)">
        <rect x="0" y="40" width="100" height="75" fill="${c.accent}"/>
        <polygon points="-8,42 50,0 108,42" fill="#7A3A2C"/>
        <rect x="35" y="70" width="30" height="45" fill="#F6F1E7"/>
        <path d="M35 70 L65 115 M65 70 L35 115" stroke="${c.accent}" stroke-width="3"/>
        <rect x="42" y="22" width="16" height="14" fill="#F6F1E7"/>
      </g>
      <g transform="translate(275 270)"><ellipse cx="0" cy="0" rx="26" ry="16" fill="#F6F1E7"/><circle cx="26" cy="-8" r="10" fill="#F6F1E7"/><rect x="-18" y="10" width="5" height="16" fill="#3B4B54"/><rect x="12" y="10" width="5" height="16" fill="#3B4B54"/><circle cx="-6" cy="-3" r="5" fill="#3B4B54"/></g>`,
    elephant: (c) => `
      <g transform="translate(200 250)" fill="#8A97A0">
        <ellipse cx="0" cy="0" rx="62" ry="42"/>
        <circle cx="58" cy="-22" r="30"/>
        <ellipse cx="44" cy="-20" rx="20" ry="26" fill="#9EA9B1"/>
        <path d="M82 -14 Q100 20 86 46" stroke="#8A97A0" stroke-width="12" fill="none" stroke-linecap="round"/>
        <rect x="-44" y="28" width="18" height="36" rx="4"/><rect x="-10" y="30" width="18" height="34" rx="4"/><rect x="24" y="28" width="18" height="36" rx="4"/>
        <circle cx="66" cy="-30" r="3.5" fill="#2A3238"/>
      </g>
      <g transform="translate(100 200)"><rect x="-4" y="0" width="8" height="70" fill="#7A5A3A"/><ellipse cx="0" cy="0" rx="46" ry="14" fill="${c.accent}"/></g>`,
    truck: (c) => `
      <g transform="translate(110 255)">
        <rect x="0" y="0" width="120" height="50" rx="6" fill="${c.accent}"/>
        <rect x="120" y="12" width="56" height="38" rx="6" fill="#E9DCC0"/>
        <rect x="132" y="18" width="30" height="16" rx="3" fill="#2F4150"/>
        <circle cx="30" cy="56" r="15" fill="#20303C"/><circle cx="30" cy="56" r="6" fill="#B9C6CF"/>
        <circle cx="150" cy="56" r="15" fill="#20303C"/><circle cx="150" cy="56" r="6" fill="#B9C6CF"/>
        <circle cx="174" cy="40" r="5" fill="#FFF2C4"/>
        <path d="M170 34 L230 18 L230 64 Z" fill="#FFF2C4" opacity=".18"/>
      </g>`,
    dino: (c) => `
      <g transform="translate(170 240)" fill="#5E8063">
        <ellipse cx="0" cy="30" rx="70" ry="38"/>
        <path d="M40 10 Q80 -30 82 -88" stroke="#5E8063" stroke-width="22" fill="none" stroke-linecap="round"/>
        <ellipse cx="94" cy="-92" rx="24" ry="14"/>
        <path d="M-60 34 Q-110 40 -130 70 Q-90 60 -55 50 Z"/>
        <rect x="-44" y="52" width="18" height="40" rx="6"/><rect x="24" y="52" width="18" height="40" rx="6"/>
        <circle cx="102" cy="-96" r="3" fill="#20303C"/>
        <path d="M-30 -2 L-20 -16 L-10 -4 L0 -18 L10 -6 L20 -18 L30 -4" fill="${c.accent}"/>
      </g>`,
    castle: (c) => `
      <g transform="translate(120 170)" fill="#F7EEE9">
        <rect x="40" y="60" width="80" height="110"/>
        <rect x="0" y="40" width="40" height="130"/><rect x="120" y="40" width="40" height="130"/>
        <polygon points="-6,42 20,-10 46,42" fill="${c.accent}"/><polygon points="114,42 140,-10 166,42" fill="${c.accent}"/>
        <polygon points="34,62 80,10 126,62" fill="#D8B7AE"/>
        <path d="M66 170 L66 130 Q80 112 94 130 L94 170 Z" fill="#C99A8F"/>
        <rect x="14" y="70" width="12" height="18" rx="6" fill="#C99A8F"/><rect x="134" y="70" width="12" height="18" rx="6" fill="#C99A8F"/>
        <path d="M20 -10 L20 -28 L34 -22 L20 -16" fill="${c.accent}"/>
      </g>`,
    firetruck: (c) => `
      <g transform="translate(95 245)">
        <rect x="0" y="10" width="150" height="54" rx="6" fill="#B5563F"/>
        <rect x="150" y="18" width="60" height="46" rx="6" fill="#B5563F"/>
        <rect x="160" y="24" width="34" height="18" rx="3" fill="#E9F0F2"/>
        <rect x="10" y="-4" width="130" height="8" fill="#E9DCC0"/>
        <path d="M14 -4 V4 M34 -4 V4 M54 -4 V4 M74 -4 V4 M94 -4 V4 M114 -4 V4" stroke="#B5563F" stroke-width="3"/>
        <rect x="180" y="8" width="16" height="8" rx="2" fill="#4A90C2"/>
        <circle cx="40" cy="66" r="15" fill="#20303C"/><circle cx="180" cy="66" r="15" fill="#20303C"/>
        <circle cx="40" cy="66" r="6" fill="#E9DCC0"/><circle cx="180" cy="66" r="6" fill="#E9DCC0"/>
        <rect x="20" y="26" width="110" height="6" fill="#E9DCC0"/>
      </g>`,
    lighthouse: (c) => `
      <path d="M232 112 L400 60 L400 150 Z" fill="#FFF3C9" opacity=".55"/>
      <g transform="translate(190 100)">
        <polygon points="8,40 42,40 52,200 -2,200" fill="#F7F3EC"/>
        <polygon points="5,80 45,80 47,110 3,110" fill="${c.accent}"/>
        <polygon points="1,145 49,145 51,175 -1,175" fill="${c.accent}"/>
        <rect x="6" y="14" width="38" height="26" fill="#F7E1A0"/>
        <polygon points="2,14 25,-6 48,14" fill="#33454E"/>
        <rect x="0" y="38" width="50" height="5" fill="#33454E"/>
      </g>
      <g transform="translate(70 290)"><rect x="0" y="0" width="44" height="28" fill="#B5563F"/><polygon points="-4,0 22,-18 48,0" fill="#33454E"/><rect x="16" y="10" width="10" height="18" fill="#F7F3EC"/></g>`,
    rocket: (c) => `
      <g transform="translate(200 210) rotate(18)">
        <path d="M0 -90 C30 -60 30 20 22 50 L-22 50 C-30 20 -30 -60 0 -90 Z" fill="#F7F3EC"/>
        <circle cx="0" cy="-26" r="13" fill="${c.accent}"/><circle cx="0" cy="-26" r="7" fill="#DCE7EA"/>
        <path d="M-22 22 L-44 62 L-20 50 Z M22 22 L44 62 L20 50 Z" fill="#B5563F"/>
        <path d="M-12 52 Q0 92 12 52 Z" fill="#E39A4F"/>
      </g>
      <g fill="#FFFFFF" opacity=".9"><ellipse cx="90" cy="120" rx="40" ry="14"/><ellipse cx="115" cy="110" rx="24" ry="14"/><ellipse cx="310" cy="160" rx="34" ry="11"/></g>`,
    star: (c) => `
      <g transform="translate(200 105)"><polygon points="0,-34 9,-11 34,-11 14,4 21,28 0,14 -21,28 -14,4 -34,-11 -9,-11" fill="${c.sun}"/></g>
      <g transform="translate(60 250)">
        <rect x="0" y="20" width="60" height="50" fill="#B5563F"/><polygon points="-6,22 30,-8 66,22" fill="#EEF2F5"/><rect x="22" y="36" width="16" height="16" fill="#F7D98A"/>
        <rect x="200" y="30" width="70" height="44" fill="#B5563F"/><polygon points="194,32 235,2 276,32" fill="#EEF2F5"/><rect x="214" y="44" width="14" height="14" fill="#F7D98A"/><rect x="242" y="44" width="14" height="14" fill="#F7D98A"/>
      </g>
      <g transform="translate(200 270)"><polygon points="0,-40 26,20 -26,20" fill="#3E5A4F"/><polygon points="0,-20 32,44 -32,44" fill="#3E5A4F"/><rect x="-5" y="44" width="10" height="12" fill="#5A4030"/></g>`
  };

  function scene(story, opts) {
    opts = opts || {};
    const c = story.scene, v = opts.variant || 0;
    const sunX = 70 + ((v * 67) % 260), sunY = story.night ? 70 : 90 + (v % 3) * 12;
    const id = 'c' + Math.random().toString(36).slice(2, 8);
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" preserveAspectRatio="xMidYMid slice">`;
    svg += `<defs><clipPath id="${id}"><circle cx="0" cy="0" r="46"/></clipPath></defs>`;
    svg += `<rect width="${W}" height="${H}" fill="${c.sky}"/>`;
    if (story.night) svg += stars(40, 7 + v, '#F4EEDC');
    svg += `<circle cx="${sunX}" cy="${sunY}" r="${story.night ? 22 : 34}" fill="${c.sun}" opacity="${story.night ? 1 : .9}"/>`;
    svg += hills(250, 18, c.far, v * 0.9);
    svg += hills(305, 12, c.near, v * 1.7 + 1);
    svg += MOTIFS[story.motif] ? MOTIFS[story.motif](c) : '';
    if (opts.photo) {
      // Demo personalisation: the child's photo as a framed medallion.
      const px = opts.photoPos === 'left' ? 78 : 322;
      svg += `<g transform="translate(${px} 84)"><circle r="50" fill="#F6F1E7"/><image href="${opts.photo}" x="-46" y="-46" width="92" height="92" preserveAspectRatio="xMidYMid slice" clip-path="url(#${id})"/></g>`;
    }
    svg += `</svg>`;
    return svg;
  }

  const api = { scene, W, H };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.FabulaArt = api;
})(typeof window !== 'undefined' ? window : globalThis);
